import { MaterialQuantityUnit } from "src/store/api/generatedApi";

interface DiffValue {
  value: number;
  diffFromPreviousStage: number;
}

interface ImportantHeatValues {
  pricePerTonTapped: DiffValue;
  pricePerTonAdded: DiffValue;
  yield: DiffValue;
  numberOfBaskets: DiffValue;
}

export interface HeatMaterial {
  name: string;
  value: number;
  unit: MaterialQuantityUnit;
  diffFromPreviousStage: number;
  ignored?: boolean;
  highlighted: boolean;
}

export type HeatMaterialWithColor = HeatMaterial & {
  color: string;
};

export interface HeatDetailPlotsData {
  source: "suggestedSource" | "deployedSource" | "plannedSource" | "level2";
  materials: HeatMaterial[];
  diffs: {
    materialName: string;
    massDiffFromPreviousStage: number;
  }[];
  user: {
    name: string;
    user_uid: string;
    email: string;
    submittedByHuman: boolean;
  };
  baskets: {
    basketNumber: number;
    materials: (HeatMaterial & {
      basketLayer: string;
    })[];
  }[];
  importantHeatValues: ImportantHeatValues;
}

export type MixViewAs = "mass" | "lifts" | "liftRecipe";

export type MixDetailView = "total" | "perBasket";

export type MixValueMode = "mass_fraction" | "mass" | "small_mass";

export type MixDisplayMode =
  "liftRecipe" | "lifts" | "mass_fraction" | "mass" | "small_mass";

export const mixViewFor = (mode: MixDisplayMode): MixViewAs =>
  mode === "liftRecipe" || mode === "lifts" ? mode : "mass";

export const mixValueModeFor = (mode: MixDisplayMode): MixValueMode =>
  mode === "mass_fraction" || mode === "small_mass" ? mode : "mass";

export interface ProcessedMaterial {
  name: string;
  materialOrdinal: number;
  value: number;
  diff: number | null;
  isPresent: boolean;
  color: string;
}

export interface ProcessedBasketSource {
  sourceName: string;
  ordering: number;
  materials: ProcessedMaterial[];
  hasBasket: boolean;
}

export interface ProcessedBasketComparison {
  basketNumber: number;
  sources: ProcessedBasketSource[];
  allMaterials: { name: string; materialOrdinal: number }[];
}

export interface ProcessedNonBasketSource {
  sourceName: string;
  ordering: number;
  materials: ProcessedMaterial[];
}

export interface BasketComparisonResult {
  baskets: ProcessedBasketComparison[];
  nonBasketMaterials: ProcessedNonBasketSource[];
  hasNonBasketMaterials: boolean;
}
